import { faComment } from "@fortawesome/free-solid-svg-icons";
import { reduce } from "et3-type-guards";
import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import UserSaveIcon from "./UserSaveIcon";
import Et3Text from "../../../../../core/et3-text";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import Et3TextInput from "../../../../../core/et3-input/et3-text-input";
import ET3Div from "../../../../../core/et3-div";
import {
  ADD_COMMENT_LABEL_WIDTH,
  ADD_COMMENT_ROW_HEIGHT
} from "./comments-box-constants";

const UserAddCommentsTable = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const userID = getUserAdvancedStore().currentUserId.get();
  const commentsNumber = reduce(
    () => getUserAdvancedStore().userData.get(userID).commentsNumber,
    0
  );

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={0}
      height={ADD_COMMENT_ROW_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="space-between"
      color={colors.all.transparent}
      onClick={() => {}}
      style={{ width: "100%" }}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={ADD_COMMENT_LABEL_WIDTH}
        height={ADD_COMMENT_ROW_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{ flexShrink: 0 }}
        onClick={() => {}}
      >
        <Et3Text
          text={i18n.get("USER_ALL_COMMENTS")}
          fontFamily="MEDIUM"
          fontSize={14}
          color={colors.all.black}
          isSpan={true}
          style={{}}
        />
        <Et3Margin left={5} right={0} top={0} bottom={0} />
        <Et3Text
          text={`${commentsNumber}`}
          fontFamily="BOLD"
          fontSize={14}
          color={colors.all.red}
          isSpan={true}
          style={{}}
        />
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={0}
        height={ADD_COMMENT_ROW_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{ flex: 1, minWidth: 0 }}
        onClick={() => {}}
      >
        <Et3TextInput
          withShadow={true}
          icon={faComment}
          type={"textarea"}
          label={""}
          size="EXTRA_LARGE"
          placeHolder={i18n.get("ADD_COMMENT")}
          value={getUserAdvancedStore().adminCommentText.get()}
          onChoose={(target: string) => {
            getUserAdvancedStore().setAdminUserComment(target);
          }}
          onBlur={() => {}}
          onEnter={() => {}}
          style={{ width: "100%", minWidth: 0 }}
        />
        <Et3Margin left={20} right={0} top={0} bottom={0} />
        <UserSaveIcon />
      </ET3Div>
    </ET3Div>
  );
});
export default UserAddCommentsTable;
